const menuBtn = document.querySelector('[data-menu-btn]');
const header = document.querySelector('header');
const menuBlock = document.querySelector('[data-menu-block]');
const menuLinksButtons = menuBlock.querySelectorAll('a, button');

menuBtn.addEventListener('click', () => {
  header.classList.toggle('active');
});

menuLinksButtons.forEach((element) => {
  element.addEventListener('click', () => {
    if (window.innerWidth < 1024) {
      header.classList.remove('active');
    }
  });
});
